export default __webpack_public_path__ + "static/media/cosmic-drive-desktop.324f9782.mp4";